import useHttpClient from 'hooks/useHttpsClient'
import Toast from 'components/toast/Toast';

const useEnterpriseService = () => {
    const { sendRequest } = useHttpClient();
    const showErrorMessage = (message) => {
        Toast.error(message)
      };

    const getScoreDistribution = async () => {
        try {
            const response = await sendRequest('/analytics/spp', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching Pie Chart data")
        }
    }
    
    const getMostPracticedScenarios = async () => {
        try {
            const response = await sendRequest('/analytics/mps', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching Most Practiced scenarios data")
        }
    }

    const getManagerProgress = async () => {
        try {
            const response = await sendRequest('/analytics/mp', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching Managers progress data")  
        }
    }
    const getGlobalScoreAndScenarios = async () => {
        try {
            const response = await sendRequest('/analytics/gsas', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching globale score and scenario data")
        }
    }

    const getEnterpriseKPIs = async () => {
        try {
            const response = await sendRequest('/analytics/ek', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching enterpries kpis data")
        }
    }
    const getBehaviorStats = async () => {
        try {
            const response = await sendRequest('/analytics/bs', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem fetching enterpries kpis data")
        }
    }

    return {
        getScoreDistribution,
        getMostPracticedScenarios,
        getManagerProgress,
        getGlobalScoreAndScenarios,
        getEnterpriseKPIs,
        getBehaviorStats,
    }
}

export default useEnterpriseService